import './interfaces-events-badges-v1-event-badges-spi.public.js';
import { createServicePluginModule } from '@wix/sdk-runtime/service-plugin-modules';
import { BuildServicePluginDefinition } from '@wix/sdk-types';
import { provideHandlers as publicProvideHandlers } from './interfaces-events-badges-v1-event-badges-spi.public.js';

export { publicProvideHandlers };

export const provideHandlers: BuildServicePluginDefinition<
  typeof publicProvideHandlers
> &
  typeof publicProvideHandlers = /*#__PURE__*/ createServicePluginModule(
  publicProvideHandlers
);
